(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bibimood-free-content"] && !Shopify.designMode) return;
  try {
    

class BibimoodWithdrawal extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    const form = this.querySelector('form');
    const button = this.querySelector('[data-withdrawal-submit]');
    if (!form || !button) return;
    this.abortController = new AbortController();
    const fields = this.querySelector('[data-withdrawal-fields]');
    const review = this.querySelector('[data-withdrawal-review]');
    const edit = this.querySelector('[data-withdrawal-edit]');
    const next = this.querySelector('[data-withdrawal-next]');
    let reviewing = false;
    next.hidden = false;
    button.hidden = true;
    const returnToFields = () => {
      reviewing = false;
      fields.hidden = false;
      review.hidden = true;
      button.hidden = true;
      next.hidden = false;
      this.querySelector('#WithdrawalName').focus();
    };
    edit.addEventListener('click', returnToFields, { signal: this.abortController.signal });
    const showReview = () => {
      if (!form.reportValidity()) return;
      for (const target of this.querySelectorAll('[data-summary-for]')) {
        target.textContent = this.querySelector('#' + target.dataset.summaryFor).value.trim();
      }
      fields.hidden = true;
      review.hidden = false;
      reviewing = true;
      next.hidden = true;
      button.hidden = false;
      this.querySelector('#WithdrawalReviewTitle').focus();
    };
    next.addEventListener('click', showReview, { signal: this.abortController.signal });
    form.addEventListener('keydown', (event) => {
      if (!reviewing && event.key === 'Enter' && event.target instanceof HTMLInputElement) {
        event.preventDefault();
        showReview();
      }
    }, { signal: this.abortController.signal });
    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      if (!reviewing) {
        event.preventDefault();
        showReview();
        return;
      }
      this.querySelector('[data-withdrawal-date]').value = new Date().toISOString();
    }, { signal: this.abortController.signal });
  }
  disconnectedCallback() { this.abortController?.abort(); this.abortController = null; }
}
if (!customElements.get('bibimood-withdrawal')) customElements.define('bibimood-withdrawal', BibimoodWithdrawal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bibimood-free-footer"] && !Shopify.designMode) return;
  try {
    
function setupBibimoodRibbon() {
  for (const ribbon of document.querySelectorAll('[data-bibi-ribbon]')) {
    const toggle = ribbon.querySelector('[data-bibi-ribbon-toggle]');
    if (!toggle || toggle.dataset.ready) continue;
    toggle.dataset.ready = 'true';
    toggle.addEventListener('click', () => {
      const paused = ribbon.dataset.paused !== 'true';
      ribbon.dataset.paused = String(paused);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
      toggle.textContent = paused ? 'Reprendre' : 'Pause';
    });
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupBibimoodRibbon, { once: true });
else setupBibimoodRibbon();
document.addEventListener('shopify:section:load', setupBibimoodRibbon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bibimood-free-product"] && !Shopify.designMode) return;
  try {
    
// Keep the floating purchase action away from the primary and accessory actions.
function setupBibimoodFloatingPurchase() {
  const bar = document.querySelector('.bibi-mobile-add');
  const primary = document.querySelector('.bibi-product-form .bibi-add-button');
  const complement = document.querySelector('.bibi-product-complement');
  if (!bar || !primary || bar.dataset.visibilityReady) return;
  bar.dataset.visibilityReady = 'true';
  const controller = new AbortController();
  const section = primary.closest('.shopify-section');
  let frame = 0;
  const update = () => {
    frame = 0;
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const accessory = complement && !complement.hidden ? complement.getBoundingClientRect() : null;
    const accessoryVisible = accessory && accessory.bottom > -24 && accessory.top < viewportHeight + 96;
    bar.hidden = primary.getBoundingClientRect().bottom > 0 || Boolean(accessoryVisible);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
  window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
  document.addEventListener('shopify:section:unload', event => {
    if (section && event.target === section) {
      controller.abort();
      cancelAnimationFrame(frame);
    }
  }, { signal: controller.signal });
  update();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupBibimoodFloatingPurchase, { once: true });
} else {
  setupBibimoodFloatingPurchase();
}
document.addEventListener('shopify:section:load', setupBibimoodFloatingPurchase);





document.querySelectorAll('[data-bibi-info-target]').forEach((link) => {
  link.addEventListener('click', (event) => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.dataset.bibiInfoTarget);
    if (!target) return;
    event.preventDefault();
    const details = target.closest('details');
    if (details) details.open = true;
    const focusTarget = target.tagName === 'DETAILS' ? target.querySelector('summary') : target;
    focusTarget?.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bibimood-q4-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bibi-compare-link]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const target = document.getElementById('choisir-chauffe-biberon');
    if (!target) return;
    event.preventDefault();
    target.open = true;
    target.querySelector('summary')?.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  });
});

function openBibimoodComparisonFromHash() {
  if (window.location.hash !== '#choisir-chauffe-biberon') return;
  const comparison = document.getElementById('choisir-chauffe-biberon');
  if (!comparison) return;
  comparison.open = true;
  comparison.querySelector('summary')?.focus({ preventScroll: true });
  comparison.scrollIntoView({ block: 'start', behavior: 'instant' });
}
window.addEventListener('hashchange', openBibimoodComparisonFromHash);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openBibimoodComparisonFromHash, { once: true });
} else {
  openBibimoodComparisonFromHash();
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bibimood-withdrawal"] && !Shopify.designMode) return;
  try {
    
  const withdrawalSection = document.querySelector('[data-withdrawal-section]');

  if (withdrawalSection) {
    const withdrawalForm = withdrawalSection.querySelector('#BibimoodWithdrawalForm');
    const reviewButton = withdrawalSection.querySelector('[data-review-withdrawal]');
    const editButton = withdrawalSection.querySelector('[data-edit-withdrawal]');
    const fields = withdrawalSection.querySelector('[data-withdrawal-fields]');
    const preview = withdrawalSection.querySelector('[data-withdrawal-preview]');
    const receipt = withdrawalSection.querySelector('[data-withdrawal-receipt]');
    const receiptActions = withdrawalSection.querySelector('[data-receipt-actions]');
    const downloadReceipt = withdrawalSection.querySelector('[data-download-receipt]');
    const printReceipt = withdrawalSection.querySelector('[data-print-receipt]');
    const storageKey = 'bibimoodWithdrawalReceipt';
    const autoDownloadKey = 'bibimoodWithdrawalReceiptDownloaded';

    const values = () => ({
      name: withdrawalSection.querySelector('#WithdrawalName')?.value.trim() || '',
      order: withdrawalSection.querySelector('#WithdrawalOrder')?.value.trim() || '',
      contract: withdrawalSection.querySelector('#WithdrawalContract')?.value.trim() || '',
      email: withdrawalSection.querySelector('#WithdrawalEmail')?.value.trim() || '',
      date: new Date().toISOString(),
    });

    const receiptText = (data) => [
      withdrawalSection.dataset.receiptTitle,
      `${withdrawalSection.dataset.receiptDate} : ${new Date(data.date).toLocaleString('fr-FR')}`,
      `${withdrawalSection.dataset.receiptName} : ${data.name}`,
      `${withdrawalSection.dataset.receiptOrder} : ${data.order}`,
      `${withdrawalSection.dataset.receiptContract} : ${data.contract}`,
      `${withdrawalSection.dataset.receiptEmail} : ${data.email}`,
      'Destinataire : Bibimood — contactbibimood@gmail.com',
    ].join('\n');

    const showPreview = () => {
      if (!withdrawalForm?.reportValidity()) return;
      const data = values();
      withdrawalSection.querySelector('[data-preview-name]').textContent = data.name;
      withdrawalSection.querySelector('[data-preview-order]').textContent = data.order;
      withdrawalSection.querySelector('[data-preview-contract]').textContent = data.contract;
      withdrawalSection.querySelector('[data-preview-email]').textContent = data.email;
      const bodyField = withdrawalSection.querySelector('[data-withdrawal-body]');
      if (bodyField) bodyField.value = receiptText(data);
      fields.hidden = true;
      reviewButton.hidden = true;
      preview.hidden = false;
      preview.focus({ preventScroll: true });
      preview.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    reviewButton?.addEventListener('click', showPreview);

    editButton?.addEventListener('click', () => {
      preview.hidden = true;
      fields.hidden = false;
      reviewButton.hidden = false;
      withdrawalSection.querySelector('#WithdrawalName')?.focus();
    });

    withdrawalForm?.addEventListener('submit', (event) => {
      if (preview?.hidden) {
        event.preventDefault();
        showPreview();
        return;
      }
      sessionStorage.setItem(storageKey, JSON.stringify(values()));
      sessionStorage.removeItem(autoDownloadKey);
    });

    if (receipt && downloadReceipt && receiptActions) {
      const saved = sessionStorage.getItem(storageKey);
      if (saved) {
        const text = receiptText(JSON.parse(saved));
        receipt.textContent = text;
        receipt.hidden = false;
        receiptActions.hidden = false;
        downloadReceipt.href = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
        if (!sessionStorage.getItem(autoDownloadKey)) {
          sessionStorage.setItem(autoDownloadKey, 'true');
          requestAnimationFrame(() => downloadReceipt.click());
        }
      }
    }

    printReceipt?.addEventListener('click', () => window.print());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-upsell-bibimood"] && !Shopify.designMode) return;
  try {
    
  class ProductUpsellBibimood extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('[data-upsell-source]');
      this.items = this.querySelector('[data-upsell-items]');
      this.load();
    }

    async load() {
      const links = [...this.source.querySelectorAll('a[href*="/products/"]')].slice(0, 2);
      if (!links.length) return;

      const products = await Promise.all(
        links.map(async (link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            const response = await fetch(`${url.pathname}.js`);
            if (!response.ok) return null;
            return { product: await response.json(), href: url.pathname };
          } catch {
            return null;
          }
        })
      );

      const validProducts = products.filter(Boolean);
      if (!validProducts.length) return;

      this.items.replaceChildren(...validProducts.map((item) => this.card(item)));
      this.items.hidden = false;
      this.source.hidden = true;
    }

    card({ product, href }) {
      const link = document.createElement('a');
      const image = document.createElement('img');
      const content = document.createElement('div');
      const title = document.createElement('strong');
      const price = document.createElement('span');
      const arrow = document.createElement('b');

      link.className = 'bibimood-product-upsell__card';
      link.href = href;
      image.src = product.featured_image;
      image.alt = product.title;
      image.loading = 'lazy';
      title.textContent = product.title;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.dataset.currency,
      }).format(product.price / 100);
      arrow.textContent = '+';
      arrow.setAttribute('aria-hidden', 'true');
      content.append(title, price);
      link.append(image, content, arrow);
      return link;
    }
  }

  if (!customElements.get('product-upsell-bibimood')) {
    customElements.define('product-upsell-bibimood', ProductUpsellBibimood);
  }

  } catch(e) { console.error(e); }
})();
})();
